/** Keep keys in sync with webrtc-node-api/src/util/CallAckMessages.js */
export const CALL_ACK_OPTIONS = [
    { key: 'on_the_way', label: 'I am on the way' },
    { key: 'reach_30_sec', label: 'I will reach in thirty seconds' },
    { key: 'reach_1_min', label: 'I will reach in one minute' },
];

export default CALL_ACK_OPTIONS;
